import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import moduleMetas from 'modules';

// loading the sass style fot the component
import css from './styles.module.scss';

/**
 * Atom PickerPicker
 * 
 * A picker to select a picker
 */
function PickerPicker (props) {

  const [options, setOptions] = React.useState(null);

  const {
    className = "",
    children,
    name,
    label,
    src,
    apis,
    multiple,
    readOnly,
    loading,
    values,
    ...other
  } = props;

  React.useEffect(_ => {
    function modSorter (a, b) {
      return a.text.toUpperCase() > b.text.toUpperCase()
        ? 1
        : -1;
    }

    setOptions(
      Object.entries(moduleMetas?.available || {})?.map(([key, mod]) => {
        return {
          key,
          value: key,
          text: mod.title
        };
      }).sort(modSorter)
    );

  }, []);

  // React.useEffect(_ => {
  //   (import(`modules/${moduleMetas?.available?.[src || name]?.fileName}/picker/index.js`))
  //     .then((result) => {
  //       setMod({
  //         Comp: result.default
  //       });
  //     }).catch((err) => {
  //       // no picker available
  //     });
  // }, []);

  return <div
    className={`field ${css["atom__picker-picker-container"]} ${className}`}
    {...other}
  >
    <label>{label}</label>
    <Dropdown
      fluid
      deburr
      multiple={multiple}
      search
      selection
      clearable
      name={name}
      disabled={readOnly}
      // allowAdditions={!!allowAdditions}
      // onAddItem={allowAdditions && onAddItemListener}
      loading={loading || !options}
      {...other}
      value={values?.[name] || other.value}
      options={options}
    />
    {children}
  </div>;
}

export default PickerPicker;
